import request from '../utils/request'
import { encodeQuery } from '../utils/helperFunctions'
import { FETCH_TYPES } from '../utils/constants'
import { REST_API } from './API_Routes'
import ServiceBase from './ServiceBase'

export default class Asset extends ServiceBase {
  create_or_update_asset = async (SUBMIT_VALUES) => {
    const formData = new FormData()
    Object.keys(SUBMIT_VALUES).forEach((key) => {
      if (SUBMIT_VALUES[key]) {
        formData.append(key, SUBMIT_VALUES[key])
      }
    })

    const option = {
      method: FETCH_TYPES.POST,
      body: formData,
    }
    const token = true
    const isFormData = true
    const response = await request(
      SUBMIT_VALUES?.id
        ? REST_API.ASSET_UPDATE
        : REST_API.ASSET_CREATE,
      option,
      token,
      isFormData,
    )
    return response
  }
  get_asset_list = async (query) => {  

    const queryParam = encodeQuery(query)
    const response = await request(
      REST_API.EQUIPMENTS_LIST_BY_SITE + queryParam,
    )
    return response
  }
}
